export const breakpoints = {
    palm: '(max-width: 47.938em)',
    lap: '(min-width: 48em) and (max-width: 63.938em)',
    portable: '(max-width: 63.938em)',
    'lap-and-up': '(min-width: 48em)',
    desk: '(min-width: 64em)',
    'desk-wide': '(min-width: 90em)',
};

/* eslint-disable no-useless-escape */
export const validations = {
    patterns: {
        phone: /^\({0,1}((0|\+61)(2|4|3|7|8)){0,1}\){0,1}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{1}(\ |-){0,1}[0-9]{3}$/,
        email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        alpha: /^[A-Za-z\-\s]+$/,
        numeric: /[0-9 ]+/,
        date: /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/,
        taxfile: /^\d{9}$/,
        postcode: /^\d{4}$/,
    },
    messages: {
        phone: 'Please enter a valid Australian phone number',
        email: 'Please enter a valid email address',
        alpha: 'Only letters, spaces and dashes are accepted',
        numeric: 'Only numbers are allowed',
        date: 'Please enter a valid date. Accepted formats are dd/mm/yyyy, dd-mm-yyyy or dd.mm.yyyy',
        taxfile: 'A tax file number should be nine digits long',
        postcode: 'A postcode should be four digits long',
    },
};

const utils = {
    breakpoints,
    validations,
};

export default utils;



// WEBPACK FOOTER //
// ./app/scripts/components/utils.js